var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.Item.Configuration", ["require", "exports", "SuiteCommerce.FeaturedCategory.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemConfiguration = void 0;
    var ItemConfiguration = /** @class */ (function (_super) {
        __extends(ItemConfiguration, _super);
        function ItemConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ItemConfiguration, "imageNotAvailable", {
            get: function () {
                return this.get('imageNotAvailable');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemConfiguration, "activeFieldset", {
            get: function () {
                return this.get('searchApiMasterOptions.Facets.fieldset');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemConfiguration, "siteSettingsSortfield", {
            get: function () {
                return this.get('siteSettings.sortfield');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemConfiguration, "getFieldSetID", {
            get: function () {
                return this.get('featuredcategory.fieldset') || '';
            },
            enumerable: false,
            configurable: true
        });
        return ItemConfiguration;
    }(Configuration_1.Configuration));
    exports.ItemConfiguration = ItemConfiguration;
});
